import { useEffect, type ReactNode } from 'react';
import { navigate } from '../lib/router';
import { useSession } from '../stores/session';
import { Spinner } from './ui';

/** Gate a page behind login (redirects to /login?next=…). */
export function RequireAuth({ children, admin }: { children: ReactNode; admin?: boolean }) {
  const s = useSession();
  useEffect(() => {
    if (s.ready && !s.me) navigate(`/login?next=${encodeURIComponent(window.location.pathname)}`, { replace: true });
  }, [s.ready, s.me]);
  if (!s.ready || !s.me) {
    return (
      <div className="grid flex-1 place-items-center text-muted">
        <Spinner />
      </div>
    );
  }
  if (admin && s.me.role !== 'admin' && s.me.role !== 'dealer') return <div className="grid flex-1 place-items-center text-muted">Admins only.</div>;
  return <>{children}</>;
}
